'use client';
import React, { useRef } from 'react';

const TestimonialsSection = () => {
  const testimonialsData = [
    {
      text: "Our pharmaceutical firm depends on Royal Prime Labels for high-quality, compliant pharmaceutical labeling. Their fast execution and zero-defect quality have optimized our global supply chain, ensuring absolute security and regulatory compliance.",
      name: "Sarah Jenkins",
      position: "Purchase Head, Pharmaceutical Industry"
    },
    {
      text: "Our food processing group is consistently impressed with Royal Prime Labels' dedication to quality and innovative materials. Their sustainable labeling options have significantly enhanced our brand's eco-friendly presence on the shelves while keeping production efficient.",
      name: "Marcus Vance",
      position: "Managing Director, Food & Beverages Industry"
    },
    {
      text: "Our premium cosmetics brand requires high-end, premium aesthetic labeling with custom foiling and custom die cuts. Royal Prime Labels has consistently delivered breathtaking quality that defines our luxury brand presence. They are an invaluable packaging partner.",
      name: "Elena Rostova",
      position: "MD of Marketing, Cosmetics & Personal Care Industry"
    },
    {
      text: "Our industrial lubricants division demands durable, chemical-resistant labeling for our industrial product line. Royal Prime Labels delivers exceptional structural durability and fast turnaround times. Their reliability in large-scale production runs is second to none.",
      name: "David Alcott",
      position: "Purchase Head, Lubricants & Chemical Industry"
    },
    {
      text: "We choose Royal Prime Labels for our high-volume beverage runs because of their unmatched response times and impeccable label application accuracy. They are our go-to partner for premium branding and high-speed bottling lines.",
      name: "Rajesh Mehta",
      position: "Managing Director, Beverages & Brewery Industry"
    }
  ];

  const scrollContainerRef = useRef(null);

  const getInitials = (name) => {
    if (!name) return '';
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  };

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 412 + 24; 
      scrollContainerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="section-shell w-full bg-white">
      <div className="container-fluid">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-6 mb-[clamp(2.5rem,6vw,5rem)]">
          <h2 className="type-section text-left text-[#1D2B4F]">
            What Our Clients Say
          </h2>
          <div className="flex gap-[24px]">
            <button 
              onClick={() => scroll('left')}
              className="w-[48px] h-[48px] border-2 border-[#2E8B8D] rounded-full shadow-[0px_0px_2px_rgba(0,0,0,0.07),0px_1px_3px_rgba(0,0,0,0.1)] p-[12px] hover:bg-gray-100 transition-colors duration-200"
            >
              <img 
                src="/images/img_icon_iconoir.svg" 
                alt="Previous" 
                className="w-full h-full"
              />
            </button>
            <button 
              onClick={() => scroll('right')}
              className="w-[48px] h-[48px] border-2 border-[#2E8B8D] rounded-full shadow-[0px_0px_2px_rgba(0,0,0,0.07),0px_1px_3px_rgba(0,0,0,0.1)] p-[12px] hover:bg-gray-100 transition-colors duration-200"
            >
              <img 
                src="/images/img_icon_jam_icons.svg" 
                alt="Next" 
                className="w-full h-full"
              />
            </button>
          </div>
        </div>
        <div 
          ref={scrollContainerRef}
          className="flex gap-[24px] overflow-x-auto scroll-smooth snap-x snap-mandatory px-4 sm:px-6 lg:px-0"
          style={{ scrollbarWidth: 'none', 'msOverflowStyle': 'none' }}
        >
          {testimonialsData?.map((testimonial, index) => (
            <div key={index} className="w-[90vw] sm:w-[412px] flex-shrink-0 bg-white rounded-[20px] border border-gray-200 shadow-lg p-[32px] flex flex-col justify-between gap-[24px] snap-start">
              <p className="type-body text-left text-gray-700">
                &ldquo;{testimonial?.text}&rdquo;
              </p>
              <div className="flex gap-[16px] items-center">
                <div className="w-[64px] h-[64px] rounded-full bg-gradient-to-br from-[#2E8B8D] to-[#1D2B4F] text-white flex items-center justify-center font-semibold text-xl select-none shadow-sm flex-shrink-0">
                  {getInitials(testimonial?.name)}
                </div>
                <div className="flex flex-col items-start flex-1">
                  <p className="type-body font-semibold text-left text-gray-900">
                    {testimonial?.name}
                  </p>
                  <p className="type-body text-left text-gray-500">
                    {testimonial?.position}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;